import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { Observable } from 'rxjs';
import { DeviceFile, Ref } from '@common/a2files-g/file.model';
import { FileDbService } from '@common/a2files-g/services/file-db.service';
import { UploadState } from '@common/a2files-g/services/file-upload.service';


@Component({
  selector: 'lib-prime-upload-files',
  templateUrl: './prime-upload-files.component.html',
  styleUrls: ['./prime-upload-files.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrimeUploadFiles implements OnInit {
  @ViewChild('uploadButton', { static: false }) uploadButton:FileUpload;
  @Input() path: string = "files";
  @Input() collection: string = "files"
  @Input() files$: Observable<any[]>;
  @Input() fileTypes: string = ""; //".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  @Input() type = 'file';
  @Input() maxFiles: number = Number.MAX_VALUE;
  @Input() maxFileSize: number =  10000000;
  @Input() canEdit: boolean = true;
  @Input() canDelete: boolean = true;
  @Input() canView: boolean = true;
  @Input() canUpload: boolean = true;
  @Input() orderFiles: string[];
  @Input() ref: Ref;
  @Input() sort: 'date' | 'name' | null = 'name'; //Pendiente por hacer
  @Input() title: string = "Documentos";
  @Input() payload: any;
  @Input() disabled:boolean=false;
  @Input() emptyPlaceholder:string=null;

  _files=[];
  uploadFiles: Set<DeviceFile> = new Set();

  get isComplete(){
    return (this.uploadFiles.size  + this._files.length) >= this.maxFiles;
  }

  constructor(
    private fileDbService: FileDbService
  ) { }

  ngOnInit(): void {
    if (!this.files$){
      this.files$ = this.fileDbService.getByRef$(this.collection, this.ref, this.type)
    }
  }

  onUploadAuto(event){
    const files = event.files;
    for (let index = 0; index < files.length; index++) {
      const file = files[index];
      this.uploadFiles.add(file);
    }
    this.uploadButton.clear();
     //event.files == files to upload
  }


  onAction(action, index:number, extra?) {
    switch (action.type ) {
      case 'open':
        window.open(action.payload.file.url);
        break;
      case 'delete':
        this.fileDbService.delete(action.payload.file, this.collection)
      break;
      case 'edit':
        this.fileDbService.update(action.payload.file, this.collection)
        break;
    }
  }

  onUploadFileState(uploadState: UploadState, file){
    if (["canceled", "error", "success"].includes(uploadState.state)){
      this.uploadFiles.delete(file);
    }
  }
}
